import { ChangeDetectorRef, ElementRef, EventEmitter, NgZone, QueryList } from '@angular/core';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { PostImageComponent } from './post-image/post-image.component';
var CssEnum;
(function (CssEnum) {
    CssEnum["HIDDEN"] = "hidden";
    CssEnum["VISIBLE"] = "visible";
    CssEnum["MAX_CONTENT"] = "max-content";
})(CssEnum || (CssEnum = {}));
var ShowMore;
(function (ShowMore) {
    ShowMore[ShowMore["MIN_POST"] = 10] = "MIN_POST";
})(ShowMore || (ShowMore = {}));
var PostListComponent = /** @class */ (function () {
    function PostListComponent(pdfService, _ngZone, cd) {
        this.pdfService = pdfService;
        this._ngZone = _ngZone;
        this.cd = cd;
        this.displayMode = 'desktop';
        this.selectToPreviewPost = new EventEmitter();
        this.openIncompleteStory = new EventEmitter();
        this.keepOrder = false;
        this.isLayoutCompleted = new EventEmitter();
        this.activePost = null;
        this.openPreviewPostPopup = false;
    }
    PostListComponent.prototype.ngOnInit = function () {
        if (this.postList && this.postList.length > ShowMore.MIN_POST) {
            this.height = this.showMoreheight;
            this.overflow = CssEnum.HIDDEN;
        }
        else {
            this.height = CssEnum.MAX_CONTENT;
            this.overflow = CssEnum.VISIBLE;
        }
    };
    // Get ng masonry grid instance first
    PostListComponent.prototype.onNgMasonryInit = function ($event) {
        this._masonry = $event;
    };
    PostListComponent.prototype.layoutComplete = function (laidOutItems) {
        if (this._masonry) {
            if (laidOutItems && this._masonry.items.length === this.postList.length) {
                this.pdfService.incrementNumberReportReady(PostListComponent.COMPONENT_NAME);
            }
            if (Array.isArray(laidOutItems) && laidOutItems.length === this.postList.length) {
                this.isLayoutCompleted.emit(true);
            }
        }
    };
    PostListComponent.prototype.showMore = function () {
        this.height = CssEnum.MAX_CONTENT;
        this.overflow = CssEnum.VISIBLE;
    };
    PostListComponent.prototype.prependItems = function (newItems) {
        if (this._masonry) {
            // set status to 'prepend' before adding items to NgMasonryGrid otherwise default: 'append' will applied
            this._masonry.setAddStatus('prepend');
            (_a = this.postList).splice.apply(_a, [0, 0].concat(newItems));
        }
        var _a;
    };
    PostListComponent.prototype.onMouseHover = function (e, postId, postItem) {
        var _this = this;
        this.activePost = postItem;
        this.keepHoverPopup = false;
        this.openPreviewPostPopup = true;
        this.cd.detectChanges();
        setTimeout(function () {
            _this.showPreviewPopup(postId, postItem);
        }, 100);
    };
    PostListComponent.prototype.showPreviewPopup = function (postId, postItem) {
        /**
         * Four following lines of code is used fixing bug https://www.pivotaltracker.com/story/show/172276017
         * Post is shown when layout complete
         */
        var filterdPostItem = this._masonry.items.find(function (item) { return item.element.id === postId; });
        if (!filterdPostItem) {
            return;
        }
        // Create new modal from template
        var container = document.getElementById('popupcontainer');
        // post list container
        var postListContainerPos = this.postListContainer.nativeElement.getBoundingClientRect();
        // find active card element
        var element = this.postItems.find(function (post) { return post.post.urlHash === postItem.urlHash; });
        // get native element of active card
        var postContentInnerEle = element.postImageContainer.nativeElement;
        // define margin left
        var marginLeft = 30;
        // define bottom bar height
        var bottomBarHeight = this.bottomBar ? this.bottomBar.clientHeight : 100;
        // Set fields
        // specific handler for video player
        var storyVideoPlayer = this.popup.nativeElement.querySelector('.video-player-container');
        var videoHeight = 0;
        if (storyVideoPlayer && postItem.isVideo && postItem.completed) {
            videoHeight = 260 * (postItem.mediaHeight / postItem.mediaWidth);
        }
        // on mobile not need Calculate position
        if (this.displayMode === 'mobile') {
            return;
        }
        var windowHeight = document.documentElement.clientHeight - bottomBarHeight;
        // Calculate position to center over target
        var left = postContentInnerEle.offsetParent.offsetLeft - (this.popup.nativeElement.scrollWidth / 2) + (postContentInnerEle.scrollWidth / 2) + marginLeft * 2;
        var top;
        if (windowHeight < container.offsetHeight || this.popup.nativeElement.scrollHeight < container.offsetHeight) {
            top = postContentInnerEle.offsetParent.offsetTop - (this.popup.nativeElement.scrollHeight / 2) + (postContentInnerEle.scrollHeight / 2);
        }
        else {
            top = 0 - (this.popup.nativeElement.scrollHeight / 2) + (postContentInnerEle.scrollHeight / 2);
        }
        // Make sure we don't grow beyond window
        var containerOffset = this.getOffsetToWindow(container);
        // a special case with story, at the first time, popup height will not include the video height, due to video not loaded yet
        // so we need to add the video height with current popup
        var popupHeight = this.popup.nativeElement.scrollHeight < videoHeight
            ? this.popup.nativeElement.scrollHeight + videoHeight : this.popup.nativeElement.scrollHeight;
        var popupPos = {
            left: containerOffset.left + left,
            top: top,
            right: containerOffset.left + left + this.popup.nativeElement.scrollWidth,
            bottom: top + popupHeight
        };
        /**
         * when post list is collapped. Use the window as the limited box
         * when post list is expanded. Use Post list container as the limited box
         */
        var limitTop = 30;
        var limitBottom = postListContainerPos.bottom;
        if ((limitTop + windowHeight) < postListContainerPos.bottom) {
            limitBottom = limitTop + windowHeight;
            top = postContentInnerEle.offsetParent.offsetTop - (this.popup.nativeElement.scrollHeight / 2) + (postContentInnerEle.scrollHeight / 2);
        }
        limitTop = 30 - postListContainerPos.top;
        limitBottom = limitBottom - postListContainerPos.top;
        var limits = {
            left: 10,
            top: limitTop,
            right: document.documentElement.clientWidth - 10,
            bottom: limitBottom
        };
        // Offset position if any limits are hit
        if (popupPos.left < limits.left) {
            left += limits.left - popupPos.left;
        }
        if (popupPos.right > limits.right) {
            left -= popupPos.right - limits.right;
        }
        if (popupPos.top < limits.top) {
            top += limits.top - popupPos.top;
        }
        else if (popupPos.bottom > limits.bottom) {
            top -= popupPos.bottom - limits.bottom;
        }
        // Set position
        this.popup.nativeElement.style.left = left + 'px';
        this.popup.nativeElement.style.top = top + 'px';
        this.popup.nativeElement.classList.add('show');
    };
    PostListComponent.prototype.onToggleMediaPlayer = function (mediaPlayer) {
        var video = mediaPlayer.querySelector('video');
        if (video.paused) {
            mediaPlayer.classList.add('playing');
            video.play();
        }
        else {
            mediaPlayer.classList.remove('playing');
            video.pause();
        }
    };
    PostListComponent.prototype.getOffsetToWindow = function (_el) {
        var target = _el, targetWidth = target.offsetWidth, targetHeight = target.offsetHeight, targetLeft = target.offsetLeft, targetTop = target.offsetTop;
        var gleft = 0, gtop = 0, rect = { left: 0, top: 0, bottom: 0, right: 0 };
        /**
         * this is a recursive method use to calculate the offset position of current element with Window
         * @param _parent
         * @returns {{top: any; left: any; bottom: any; right: any}}
         */
        var calculateOffsetWindowRecursive = function (_parent) {
            if (!!_parent) {
                gleft += _parent.offsetLeft;
                gtop += _parent.offsetTop;
                calculateOffsetWindowRecursive(_parent.offsetParent);
            }
            else {
                return rect = {
                    top: target.offsetTop + gtop,
                    left: target.offsetLeft + gleft,
                    bottom: (target.offsetTop + gtop) + targetHeight,
                    right: (target.offsetLeft + gleft) + targetWidth
                };
            }
        };
        calculateOffsetWindowRecursive(target.offsetParent);
        return rect;
    };
    PostListComponent.prototype.onSelectedPost = function (influencer) {
        this.selectToPreviewPost.emit(influencer);
        this.hidePopupCardHover();
    };
    PostListComponent.prototype.addToPreviewed = function (item) {
        this.selectToPreviewPost.emit(item);
    };
    PostListComponent.prototype.hidePopupCardHover = function (evt) {
        var clickingOnImage = evt && evt.target && evt.target.classList.length > 0 && evt.target.classList.contains('post-img');
        if (this.popup && !this.keepHoverPopup && !clickingOnImage) {
            this.popup.nativeElement.classList.remove('show');
            this.openPreviewPostPopup = false;
        }
    };
    PostListComponent.prototype.trackByFn = function (index, item) {
        return index;
    };
    PostListComponent.COMPONENT_NAME = 'PostListComponent';
    return PostListComponent;
}());
export { PostListComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/post-list/post-list.component.ts.pre-build-optimizer.js